import React from 'react'
import { FormattedMessage } from 'react-intl'
import './label.scss'

const isRequired = (required) => (required ? '*' : '')

export const ControlLabel = ({ id, label, required }) => {
  return (
    <div className="control-label">
      <FormattedMessage id={id} defaultMessage={id} /> {isRequired(required)}
    </div>
  )
}

export const LabelCheck = ({ id, label, specificClass, required }) => {
  return (
    <label className={`control-label label-check ` + specificClass}>
      {id ? <FormattedMessage id={id} /> : label} {isRequired(required)}
    </label>
  )
}

export const SubTitle = ({ id }) => {
  return (
    <div className="title__subtitle">
      <FormattedMessage id={id} />
    </div>
  )
}
